import { useEffect } from 'react'
import { useSnapshot } from './TelephonyProvider'
import { useCommand } from './useCommand'
import { TelephonyCommandNames } from '../contract'

// Operator keyboard shortcuts (ignored while typing in a field):
//   a = answer the inbound ringing call   ·   h = hold/resume the active call   ·   e = end the active call
export function useKeyboardShortcuts(): void {
  const { calls } = useSnapshot()
  const run = useCommand()
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.metaKey || e.ctrlKey || e.altKey) return
      const t = e.target as HTMLElement | null
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) return
      const ringing = calls.find((c) => c.status === 'ringing' && c.direction === 'inbound')
      const active = calls.find((c) => c.status === 'connected' || c.status === 'on_hold')
      const k = e.key.toLowerCase()
      if (k === 'a' && ringing) {
        e.preventDefault()
        void run({ command: TelephonyCommandNames.Answer, params: { channel: ringing.channel } }, { successMessage: 'Answered' })
      } else if (k === 'e' && active) {
        e.preventDefault()
        void run({ command: TelephonyCommandNames.Hangup, params: { channel: active.channel } })
      } else if (k === 'h' && active) {
        e.preventDefault()
        void run({
          command: active.onHold ? TelephonyCommandNames.Unhold : TelephonyCommandNames.Hold,
          params: { channel: active.channel }
        })
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [calls, run])
}
